module.exports = __webpack_public_path__ + "img/city2.456b47b.jpg";